module.exports = __webpack_public_path__ + "42995c4da80504e3fd45834b360dc19e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/help/draw.svg
// module id = 158
// module chunks = 0